import { render } from "./Variant_Treatments.vue?vue&type=template&id=3bd6f41c"
import script from "./Variant_Treatments.vue?vue&type=script&lang=js"
export * from "./Variant_Treatments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__